module.exports = __webpack_public_path__ + "img/watch.d3b4878.svg";